(function () {
    angular.module('core')
      .service('edxLessonSlotsApi', [
          'cancelableResourceFactory',
          'cancelableResourceManager',
          'edxSnakeToCamelService',
          LessonSlotsApi]);

    function LessonSlotsApi(
      cancelableResourceFactory,
      cancelableResourceManager,
      snakeToCamelService
    ) {

        /**
         * See if we can deserialize the response entity.
         *
         * In an error case we can't be certain what we get back.
         *
         * @param body Response entity
         * @return {*} Error object
         * @private
         */
        function _extractErrorResponse(body) {
            try {
                return angular.fromJson(body);
            } catch (e) {

            }
            return body;
        }

        /**
         * Transform response entity to JSON.
         *
         * This will throw an exception if the call is not successful.
         *
         * @param body Response entity
         * @param headers Response headers
         * @param status Response status
         * @return {*}
         */
        function _transformResponse(body, headers, status) {
            if (status === 200) {
                return snakeToCamelService.snakeToCamel(
                  angular.fromJson(body)
                );
            } else {
                throw _extractErrorResponse(body);
            }
        }

        /**
         * Register an instance to be auto removed from resource manager.
         *
         * @param instance Resource instance
         * @return {$promise}
         * @private
         */
        function _removeOnFinish(instance) {
            cancelableResourceManager.addAndRemoveOnFinish(instance);
            return instance.$promise;
        }

        var LessonSlot = cancelableResourceFactory.createCacheableResource(
          '/api/v1/lesson_slots',
          '/api/v1/lesson_slots/:lesson_slot_id',
          {},
          {
              get: {
                  cache: true,
                  method: 'GET',
                  transformResponse: _transformResponse
              }
          });

        /**************************************************************/
        /*                          Api                               */
        /**************************************************************/

        return {
            LessonSlot: LessonSlot,
            get: function(params) {
                return _removeOnFinish(LessonSlot.get(params));
            }
        };
    }
})();
